.errorPage {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-8);
	align-items: center;
	justify-content: center;
	min-block-size: 100dvh;
	padding: var(--spacing-6);

	.logo {
		color: var(--colour-text-primary);
	}

	.badge {
		font-size: var(--font-size-xl);
		font-weight: var(--font-weight-bold);
		color: var(--colour-danger);
		letter-spacing: var(--letter-spacing-wide);
	}

	.stack {
		inline-size: min(100%, var(--width-prose));
		max-block-size: 40vh;
		padding: var(--spacing-4);
		overflow: auto;
		font-family: var(--font-family-mono);
		font-size: var(--font-size-xs);
		line-height: var(--line-height-base);
		color: var(--colour-text-secondary);
		overflow-wrap: break-word;
		white-space: pre-wrap;
		background: var(--colour-background-surface);
		border: 1px solid var(--colour-border-subtle);
		border-radius: var(--radius-md);
	}
}
